import { EffectMetadata } from "@ngrx/effects/src/models";

export const METADATA_KEY = '__@ngrx/effects__';
export const CREATE_EFFECT_METADATA_KEY = '__@ngrx/effects_create__';

export interface EffectConfig {
  dispatch?: boolean;
  useEffectsErrorHandler?: boolean;
}

export type EffectPropertyKey<T extends Object> = Exclude<
  keyof T,
  keyof Object
>;

export const DEFAULT_EFFECT_CONFIG: Readonly<Required<EffectConfig>> = {
  dispatch: true,
  useEffectsErrorHandler: true,
};

function hasMetadataEntries<T extends Object>(
  sourceProto: T
): sourceProto is typeof sourceProto & {
  constructor: typeof sourceProto.constructor & {
    [METADATA_KEY]: EffectMetadata<T>[];
  };
} {
  return sourceProto.constructor.hasOwnProperty(METADATA_KEY);
}

export function addEffectMetadataEntry<T extends object>(
  sourceProto: T,
  metadata: EffectMetadata<T>
) {
  if (hasMetadataEntries(sourceProto)) {
    sourceProto.constructor[METADATA_KEY].push(metadata);
  } else {
    Object.defineProperty(sourceProto.constructor, METADATA_KEY, {
      value: [metadata],
    });
  }
}

function getEffectMetadataEntries<T extends object>(
  sourceProto: T
): EffectMetadata<T>[] {
  return hasMetadataEntries(sourceProto)
    ? sourceProto.constructor[METADATA_KEY]
    : [];
}
